import { ADMIN_PANEL_LOGIN } from '@/constants/adminPanelRoutes';
import adminPanelService from '@/services/adminPanel';

export default function checkAdminPanelAuth() {
  if (adminPanelService.hasAuthTokens()) return true;
  return { name: ADMIN_PANEL_LOGIN };
}
